import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "regles-widget-group"
}
const _hoisted_2 = {
  key: 1,
  class: "site-widget-container"
}
const _hoisted_3 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_4 = { class: "site-widget" }
const _hoisted_5 = {
  key: 3,
  class: "container-tiles"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_NoData = _resolveComponent("NoData")!
  const _component_Tile = _resolveComponent("Tile")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, {
    widthType: _ctx.WidthType.third,
    class: "container-widget"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        iconUrl: _ctx.loadIcon,
        title: _ctx.widgetTitle,
        onClick: _ctx.navigationTo
      }, null, 8, ["iconUrl", "title", "onClick"]),
      (_ctx.widget)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ReglePastille, { cle: "dashboard.widgetPerimetreCommun" }),
            _createVNode(_component_ReglePastille, { cle: "dashboard.widgetDevisFenetreFixe" })
          ]))
        : _createCommentVNode("", true),
      (_ctx.widget)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.widget.sites == null || _ctx.widget.sites.length > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('multisites')), 1))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: site.id,
                    class: "site-widget-item"
                  }, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(site.description), 1)
                  ]))
                }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && !_ctx.getEstimateData.nbPublies && !_ctx.getEstimateData.nbEnCours && !_ctx.getEstimateData.nbRealises)
        ? (_openBlock(), _createBlock(_component_NoData, {
            key: 2,
            class: "no-data",
            textNoData: "widget.estimate.noData"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Tile, {
              isLoading: _ctx.isLoading,
              titleInBold: _ctx.$t('estimateWidget.toValidate'),
              titleNotBold: _ctx.$tc('estimateWidget.estimate'),
              value: _ctx.getEstimateData.nbPublies,
              class: "tile",
              color: "--a-valider",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filteredNavigation(_ctx.EtatDevis.publie)))
            }, null, 8, ["isLoading", "titleInBold", "titleNotBold", "value"]),
            _createVNode(_component_Tile, {
              isLoading: _ctx.isLoading,
              titleInBold: _ctx.$t('estimateWidget.awaitingRealization'),
              titleNotBold: _ctx.$t('estimateWidget.estimate'),
              value: _ctx.getEstimateData.nbEnCours,
              class: "tile",
              color: "--en-cours",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filteredNavigation(_ctx.EtatDevis.enCours)))
            }, null, 8, ["isLoading", "titleInBold", "titleNotBold", "value"]),
            _createVNode(_component_Tile, {
              isLoading: _ctx.isLoading,
              titleInBold: _ctx.$t('estimateWidget.inProgress', _ctx.getEstimateData.nbRealises),
              titleNotBold: _ctx.$t('estimateWidget.estimate'),
              value: _ctx.getEstimateData.nbRealises,
              class: "tile",
              color: "--fait",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filteredNavigation(_ctx.EtatDevis.realise)))
            }, null, 8, ["isLoading", "titleInBold", "titleNotBold", "value"])
          ]))
    ]),
    _: 1
  }, 8, ["widthType"]))
}